import AdminBlog from '../pages/Admin/AdminBlog/AdminBlog';
import AdminCategory from '../pages/Admin/AdminCategory/AdminCategory';
import SuperAdminOverview from '../pages/Admin/AdminOverview/SuperAdminOverview';
import SalonManagementOverview from '../pages/Admin/AdminSalons/SalonManagementOverview';
import UserManagement from '../pages/Admin/AdminUsers/UserManagement';
import AppointmentsPage from '../pages/Admin/AppoinementsAdmin/AppointmentsPage';
import SalonProfile from '../pages/Admin/SalonProfile/SalonProfile';
import StaffManagement from '../pages/Admin/StaffManagement/StaffManagement';
import CatalogManagement from '../pages/Admin/catalog-Management/CatalogManagement';
import ContactUsRequests from '../pages/Admin/contactUsRequests/ContactUsRequests';
import TeamMemberProfile from '../pages/Admin/teamMember/TeamMemberProfile';
import Transactions from '../pages/Admin/transactions/Transactions';
import Overview from '../pages/overview/Overview';

const routesSuperAdmin = [
  {
    path: 'admin/overview',
    element: <SuperAdminOverview />,
  },
  {
    path: 'admin',
    element: <SuperAdminOverview />,
  },
  {
    path: 'admin/salon-management',
    element: <SalonManagementOverview />,
  },
  {
    path: 'admin/salon-management/:salonName',
    element: <SalonProfile />,
  },
  {
    path: 'admin/salon-management/:salonName/:teamName',
    element: <TeamMemberProfile />,
  },
  {
    path: 'admin/clients-management',
    element: <UserManagement />,
  },

  {
    path: 'admin/appointments',
    element: <AppointmentsPage />,
  },
  {
    path: 'admin/staff-management',
    element: <StaffManagement />,
  },
  {
    path: 'admin/catalog-management',
    element: <CatalogManagement />,
  },
  {
    path: 'admin/catalog-management/services',
    element: <CatalogManagement />,
  },
  {
    path: 'admin/catalog-management/packages',
    element: <CatalogManagement />,
  },
  {
    path: 'admin/catalog-management/products',
    element: <CatalogManagement />,
  },
  {
    path: 'admin/catalog-management/gift-cards',
    element: <CatalogManagement />,
  },
  {
    path: 'admin/catalog-management/memberships',
    element: <CatalogManagement />,
  },
  {
    path: 'admin/reports-analytics',
    element: <Overview />,
  },
  {
    path: 'admin/settings',
    element: <Overview />,
  },
  {
    path: 'admin/help-support',
    element: <Overview />,
  },
  {
    path: 'admin/blogs',
    element: <AdminBlog />,
  },
  {
    path: 'admin/blog-categories',
    element: <AdminCategory />,
  },
  {
    path: 'admin/contact-us-requests',
    element: <ContactUsRequests />,
  },
  // {
  //   path: 'admin/transaction',
  //   element: <Transactions />,
  // },
];

export default routesSuperAdmin;
